export enum DlsScopes {
    Group = 1,
    Entity = 2,
    Brand = 3,
}
